import { CURRENCY_LABEL } from "@app/_helpers";

// TODO: use these names as labels instead of hardcoding in HTML
export const ORDER_BOOK_COLUMNS_MAPPINGS = {
    // 'select': 'Select',
    'strategy_type': 'Algo Type',
    'market_id': 'Exchange',
    'broker': 'Broker',
    'order_mode': 'Order Mode',
    'strategy_name': 'Algo Name',
    'scrip_name': 'Symbol',
    'instrument': 'Instrument',
    'client_order_id': 'Order Id',
    'order_price': `Price ${CURRENCY_LABEL}`,
    'order_lots': 'Lots',
    'order_type': 'Order Type',
    'order_validity': 'Order Validity',
    'product_type': 'Product',
    'order_status': 'Status',
    'portfolio_id': 'Portfolio Id',
    'filled_lots': 'Filled Lots',
    'exchange_order_id': 'Broker / Exchange Order ID',
    'exchange_order_time': 'Time',
    'order_condition': 'Order Condition',
    // 'stop_price': 'Stop Price',
    'error_text': 'Rejection Text'
};

export const TRADE_BOOK_COLUMN_MAPPINGS = {
    // 'select': 'Select',
    'strategy_type': 'Algo Type',
    'market_id': 'Exchange',
    'broker': 'Broker',
    'order_mode': 'Order Mode',
    'trade_id': 'Trade No',
    'strategy_name': 'Algo Name',
    'scrip_name': 'Symbol',
    'instrument': 'Instrument',
    'client_order_id': 'Order Id',
    'filled_price': `Price ${CURRENCY_LABEL}`,
    'order_status': 'Status',
    'product_type': 'Product',
    'portfolio_id': 'Portfolio Id',
    'filled_lots': 'Filled Lots',
    'exchange_order_id': 'Broker / Exchange Order ID',
    'trade_time': 'Trade Time',
    'order_condition': 'Order Condition'
};

export const POSITION_BOOK_COLUMN_MAPPINGS = {
    // 'select': 'Select',
    'broker': 'Broker',
    'market_id': 'Exchange',
    'scrip_name': 'Symbol',
    'buy_lots': 'Buy Lots',
    'averageBuyPrice': `Avg Buy Price ${CURRENCY_LABEL}`,
    'totalBuyValue': `Buy Amount ${CURRENCY_LABEL}`,
    'sell_lots': 'Sell Lots',
    'averageSellPrice': `Avg Sell Price ${CURRENCY_LABEL}`,
    'totalSellValue': `Sell Amount ${CURRENCY_LABEL}`,
    'openQuantity': 'Net Lots',
    'net_value': `Net Value ${CURRENCY_LABEL}`,
    'mtm': `MTM ${CURRENCY_LABEL}`,
    'bookedPL': `Booked P/L ${CURRENCY_LABEL}`,
    'net_pnl': `Net P/L ${CURRENCY_LABEL}`,
    'product': 'Product',
    'position_type': 'Position Type',
    'ltp': `LTP ${CURRENCY_LABEL}`
};

export const AFFILIATE_STATUS_MAPPINGS = {
    'date': 'Date',
    'login_source': 'Client Type',
    'client_id': 'Client ID',
    'client_name': 'Client Name',
    'referral_code': 'Referral Code',
    'utm': 'UTM',
    'mobile': 'Mobile',
    'city': 'City',
    'state': 'Stage',
    'client_code': 'UCC'
}

export const AFFILIATE_FUNDS_MAPPINGS = {
    'date': 'Date',
    'clientId': 'Client ID',
    'clientName': 'Client Name',
    'ucc': 'UCC',
    'pancard': 'Pan Card',
    'strategyName': 'Strategy Name',
    'strategyType': 'Strategy Type',
    'ubpc': 'UBPC',
    'rm': 'RM',
    'cash': 'Cash',
    'adhoc': 'Adhoc',
    'additional': 'Additional',
    'marginUntilized': 'Margin Utilized',
    'strategyStartTime': 'Strategy Start Time',
    'marginBlocked': 'Amount',
    'strategyEndTime': 'Strategy End Time',
    "pnl": "PnL"
}


export const ORDER_BOOK_COLUMNS = [
    'strategy_type', 'scrip_name', 'market_id', 'instrument', 'order_mode', 'order_lots', 'filled_lots', 'order_price', 'order_status', 'order_condition',
    'strategy_name', 'exchange_order_time', 'broker', 'client_order_id', 'order_type', 'order_validity', 'product_type', 'portfolio_id',
    'error_text', // 'stop_price'
];

export const FROZEN_ORDER_BOOK_COLUMNS = [
    'strategy_type', 'strategy_name', 'client_order_id', 'portfolio_id', 'exchange_order_id'
]

export const TRADE_BOOK_COLUMNS = ['strategy_type', 'scrip_name', 'market_id', 'instrument', 'order_mode', 'filled_lots',
    'filled_price', 'order_status', 'order_condition', 'strategy_name', 'trade_time', 'broker', 'client_order_id',
    'product_type', 'trade_id', 'portfolio_id', 'exchange_order_id'
];

export const FROZEN_TRADE_BOOK_COLUMNS = [
    'strategy_type', 'strategy_name', 'trade_id', 'portfolio_id', 'client_order_id', 'exchange_order_id'
]

export const POSITION_BOOK_COLUMNS = ['position_type', 'scrip_name', 'market_id', 'buy_lots', 'averageBuyPrice',
    'totalBuyValue', 'sell_lots', 'averageSellPrice', 'totalSellValue',
    'openQuantity', 'net_value', 'mtm', 'ltp',
    'bookedPL', 'net_pnl', 'broker', 'product'];

export const FROZEN_POSITION_BOOK_COLUMNS = [
    'scrip_name', 'net_value', 'mtm', 'bookedPL', 'net_pnl'
];

export const FROZEN_AFFILIATE_STATUS_ORDER = ['date', 'client_id', 'client_name', 'client_code'];
export const FROZEN_AFFILIATE_FUNDS_ORDER = [];

export const AFFILIATE_STATUS_ORDER = ['date', 'login_source', 'client_id', 'client_name', 'referral_code', 'utm', 'mobile', 'city', 'state', 'client_code'];

export const AFFILIATE_FUNDS_ORDER = [
    'date',
    'clientId',
    'clientName',
    'ucc',
    'pancard',
    'strategyName',
    'strategyType',
    'ubpc',
    'rm',
    'cash',
    'adhoc',
    'additional',
    'marginUntilized',
    'strategyStartTime',
    'marginBlocked',
    'strategyEndTime',
    "pnl"
];

export const AFFILIATE_FUNDS_CUSTOM_FILTER_COLUMNS = [
    'strategyType'
]

export const COLUMN_NAMES_MAPPINGS = {
    "orderBook": ORDER_BOOK_COLUMNS_MAPPINGS,
    "tradeBook": TRADE_BOOK_COLUMN_MAPPINGS,
    "positionsBook": POSITION_BOOK_COLUMN_MAPPINGS,
    "affiliate_status": AFFILIATE_STATUS_MAPPINGS,
    "affiliate_funds": AFFILIATE_FUNDS_MAPPINGS,
}

export const BOOKS_MAPPING = {
    "orderBook": ORDER_BOOK_COLUMNS,
    "tradeBook": TRADE_BOOK_COLUMNS,
    "positionsBook": POSITION_BOOK_COLUMNS,
    "affiliate_status": AFFILIATE_STATUS_ORDER,
    "affiliate_funds": AFFILIATE_FUNDS_ORDER,
    "showPromotePlan": ['false']
}


export const FROZEN_BOOKS_MAPPINGS = {
    "orderBook": FROZEN_ORDER_BOOK_COLUMNS,
    "tradeBook": FROZEN_TRADE_BOOK_COLUMNS,
    "positionsBook": FROZEN_POSITION_BOOK_COLUMNS,
    "affiliate_status": FROZEN_AFFILIATE_STATUS_ORDER,
    "affiliate_funds": FROZEN_AFFILIATE_FUNDS_ORDER,
    "showPromotePlan": ['false']
}

export const STRATEGY_ORDER_BOOK_COLUMNS = ['order_mode', 'scrip_name', 'order_status', 'order_price', 'order_lots', 'filled_lots', 'order_condition', 'exchange_order_time', 'broker', 'client_order_id', 'order_type', 'error_text', 'product_type'];

export const STRATEGY_TRADE_BOOK_COLUMNS = ['order_mode', 'scrip_name', 'filled_lots', 'filled_price', 'trade_time', 'order_status', 'order_condition', 'client_order_id', 'exchange_order_id', 'broker', 'trade_id', 'product_type'];

export const STRATEGY_POSITION_BOOK_COLUMNS = ['scrip_name', 'net_pnl', 'broker', 'ltp', 'openQuantity', 'averageBuyPrice', 'averageSellPrice', 'mtm', 'bookedPL', 'net_value', 'buy_lots', 'totalBuyValue', 'sell_lots', 'totalSellValue', 'target_profit', 'stop_loss', 'product'];

export enum DownloadReportType {
    DAY_WISE = 'Daywise',
    STRATEGY_WISE = 'Strategywise'
}
export const EARNINGS_REPORT_WISE_COLUMNS = {
    [DownloadReportType.DAY_WISE] : ['Date', 'Day', 'Profit/Loss'],
    [DownloadReportType.STRATEGY_WISE] : ['Date', 'Day', 'Strategy Type' ,'Strategy Name', 'Broker', 'Profit/Loss']
}

export const AI_BACKTEST_COLUMNS = ['date', 'strategyName', 'multipliers', 'pnl', 'marginUsed'];
export const AI_BT_CSV_HEADERS = ["Date", "Strategy Name", "Multipliers", "P&L", "Margin Used"];